const getAppName = state => state.appConfig.appName;

export default getAppName;
